import * as React from "react"
export const NotePlus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    className="stroke-fg-1"
    {...props}>
    <path
      d="M17.5 8.33333V6.89024C17.5 5.35351 17.5 4.58515 17.2045 3.9982C16.9446 3.4819 16.5299 3.06213 16.0199 2.79907C15.44 2.5 14.6809 2.5 13.1627 2.5H6.83728C5.31909 2.5 4.55999 2.5 3.98012 2.79907C3.47005 3.06213 3.05535 3.4819 2.79546 3.9982C2.5 4.58515 2.5 5.35351 2.5 6.89024V13.1098C2.5 14.6465 2.5 15.4148 2.79546 16.0018C3.05535 16.5181 3.47005 16.9379 3.98012 17.2009C4.55999 17.5 5.31909 17.5 6.83728 17.5H12.0833M11.25 10H5.83333M13.3333 6.66667H5.83333M16.6667 16.6667V14.1667M16.6667 14.1667V11.6667M16.6667 14.1667H14.1667M16.6667 14.1667H19.1667"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
